module.exports = __webpack_public_path__ + "static/joomla-analytics-db6b7c32edf138b67ddeca8ce59e0de1.png";